namespace GeniuzPOS.Member {
    export class MbReport01Columns {
        static columnsKey = 'Member.MbReport01';
    }
}
